import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M22 10V8C22 7.44772 21.5523 7 21 7H11.118C10.7393 7 10.393 6.786 10.2236 6.44721L9.27639 4.55279C9.107 4.214 8.76074 4 8.38197 4H3C2.44772 4 2 4.44772 2 5L2 7V18C2 18.5523 2.44772 19 3 19H13",
  stroke: "white"
}, null, -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("rect", {
  x: "18.5",
  y: "11.5",
  width: "1",
  height: "9",
  rx: "0.5",
  stroke: "white"
}, null, -1 /* HOISTED */)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("rect", {
  x: "14.5",
  y: "16.5",
  width: "1",
  height: "9",
  rx: "0.5",
  transform: "rotate(-90 14.5 16.5)",
  stroke: "white"
}, null, -1 /* HOISTED */)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}
export default { render: render }